import { LAYOUT_COMPONENT_TYPE, REGISTRY_BLOCK, type LayoutBlock } from '@web-studio/shared-schemas';
import { loc3 } from '../locales';
import { FIXTURE_BLOCK_IDS } from '../uuids';

export const simpleMenuStripDefault: LayoutBlock = {
  blockId: FIXTURE_BLOCK_IDS.simpleMenuStrip,
  componentType: LAYOUT_COMPONENT_TYPE.simpleMenuStrip,
  registryBlockKey: REGISTRY_BLOCK.presentation.simpleMenuStrip,
  displayOrder: 3,
  content: {
    sectionTitle: loc3('Heute am Truck', 'Today on the truck', 'Hôm nay trên xe'),
    items: loc3(
      'Smash Burger — 9,50 €\nLoaded Fries — 6,50 €\nSoft Serve — 4,00 €',
      'Smash burger — 9,50 €\nLoaded fries — 6,50 €\nSoft serve — 4,00 €',
      'Smash burger — 9,50 €\nKhoai tây phủ topping — 6,50 €\nKem mềm — 4,00 €',
    ),
  },
  media: {},
};
